import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 80,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
  <svg
      className={classes.svg}
      viewBox="0 0 841.9 595.3"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fill="#0066FF"
        d="M-0.7,365.6h842.8v61.2H-0.7V365.6z"
    />
    <path
        fill="#ffffff"
        d="M408.9,312c0,18.6,9.7,43.7,52.4,43.7c42.7,0,52.3-25.1,52.3-43.7v-31.2H471V315c0,5.4,0,12.9-9.7,12.9c-9.7,0-9.7-7.5-9.7-12.9v-80.6c0-5.5,0-12.9,9.7-12.9c9.7,0,9.7,7.4,9.7,12.9V257h42.7v-19.7c0-18.6-9.7-43.7-52.3-43.7c-42.7,0-52.4,25.1-52.4,43.7V312z M526,326c0,24.8,14.2,27.8,32.5,27.8h10.1V226.1h10.7v-30.8h-10.7v-39.7H526v39.7h-10.7v30.8H526V326z M585.3,353.9H628V195.4h-42.7V353.9z M585.3,185H628v-29.3h-42.7V185z M659.8,353.9h49.8l29-158.5h-42.6l-10.7,101.5h-0.5l-9.9-101.5h-43.9L659.8,353.9z M295.5,312c0,18.6,9.7,43.7,52.3,43.7c42.7,0,52.4-25.1,52.4-43.7v-16.9h-42.7V315c0,5.4,0,12.9-9.7,12.9c-9.7,0-9.7-7.5-9.7-12.9v-34h62v-43.7c0-18.6-9.7-43.7-52.4-43.7c-42.7,0-52.3,25.1-52.3,43.7V312z M338.2,234.4c0-5.5,0-12.9,9.7-12.9c9.7,0,9.7,7.4,9.7,12.9v17.4h-19.4V234.4z M737.1,312c0,18.6,9.7,43.7,52.4,43.7c42.7,0,52.3-25.1,52.3-43.7v-16.9h-42.7V315c0,5.4,0,12.9-9.7,12.9c-9.7,0-9.7-7.5-9.7-12.9v-34h62v-43.7c0-18.6-9.7-43.7-52.3-43.7c-42.7,0-52.4,25.1-52.4,43.7V312z M779.8,234.4c0-5.5,0-12.9,9.7-12.9c9.7,0,9.7,7.4,9.7,12.9v17.4h-19.3V234.4z M45.5,205.8c0-6.7,0-18.1,13.1-18.1s13.1,11.4,13.1,18.1v98c0,5.2,0,18.1-13.1,18.1s-13.1-12.9-13.1-18.1V205.8z M-0.2,299.9c0,35.2,22.6,55.9,58.8,55.9c36.2,0,58.8-20.7,58.8-55.9v-90.1c0-38.7-24.8-55.9-58.8-55.9s-58.8,17.2-58.8,55.9V299.9z M171.2,314.8c0,5.5,0,12.9,9.7,12.9c9.7,0,9.7-7.4,9.7-12.9v-80.6c0-5.5,0-12.9-9.7-12.9c-9.7,0-9.7,7.4-9.7,12.9V314.8z M171.1,350.9v2.9h-42.7V155.6h42.7v41.8c3.1-2.2,9.6-4,13-4c40,0,49.1,25.1,49.1,43.7v74.7c0,18.6-8.8,43.7-47.9,43.7c-3.4,0-11.1-1.5-14.2-4.6V350.9z M243.2,383.9h10.1c30,0,32.6-17.7,32.6-41.6V195.4h-42.7V383.9z M243.2,155.7h42.7V185h-42.7V155.7z"
    />
  </svg>
  );
};

export default LogoFull;
